const meriDesign = [
    {
        path: '/meri-design',
        name: 'meriDesign',
        component: () => import('../views/meriDesign/index.vue')
    },
   
]

export default meriDesign